import AbstractMetricProtocol from '@/app/modules/Metrics/classes/AbstractMetricProtocol';
import { signal } from '../adapters/ClickStream';
import { DivolteEvent } from '@/app/modules/Metrics/loaders/ClickStream';

export default class ClickstreamProtocol extends AbstractMetricProtocol {
    protected prepareCSCData(value: DivolteEvent) {
        if (this.extraEventData.layer) {
            value.ObjName = this.extraEventData.layer;
        }

        if (this.extraEventData.bannerID) {
            value.ObjId = this.extraEventData.bannerID;
        }

        if (value.ObjVal && typeof value.ObjVal === 'object') {
            value.ObjVal = JSON.stringify(value.ObjVal);
        }

        return value;
    }

    public send() {
        signal(this.prepareCSCData(this.value));
    }
}
